import { useEffect, useState } from 'react'
import api from '../../../lib/api'
import { enableWarmup } from '../../../lib/onboardingApi'

export default function WarmupStep({ onDone }) {
  const [accts, setAccts] = useState([])
  const [chosen, setChosen] = useState(null)
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  useEffect(() => {
    api.get('/email/accounts').then(r => {
      const list = r.data || []
      setAccts(list)
      if (list.length) setChosen(list[0].id)
    }).catch(() => setErr('Could not load mailboxes.'))
  }, [])

  const onEnable = async () => {
    if (!chosen) return
    setBusy(true); setErr(null)
    try {
      await enableWarmup(chosen)
      onDone()
    } catch (e) {
      setErr('Warmup enable failed. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <p style={{ color: '#aaa', fontSize: 14, lineHeight: 1.6 }}>
        Warmup ramps your daily send volume from 2 → 50+ over 60 days. Reply rate
        and inbox placement track your reputation automatically.
      </p>
      {accts.length === 0 ? (
        <p style={{ color: '#f59e0b', marginTop: 20 }}>Connect a mailbox first.</p>
      ) : (
        <>
          <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 18, marginBottom: 6 }}>
            Mailbox
          </label>
          <select
            value={chosen || ''} onChange={e => setChosen(Number(e.target.value))}
            style={{ width: '100%', padding: 10, background: '#1a1d29', color: '#e5e7eb',
                     border: '1px solid #2a2d3a', borderRadius: 6 }}
          >
            {accts.map(a => <option key={a.id} value={a.id}>{a.email}</option>)}
          </select>
          <button
            onClick={onEnable} disabled={busy || !chosen}
            style={{ marginTop: 22, background: '#3b82f6', color: '#fff', border: 'none',
                     padding: '10px 18px', borderRadius: 6, fontWeight: 600,
                     cursor: busy ? 'wait' : 'pointer' }}
          >
            {busy ? 'Starting…' : 'Start warmup with defaults'}
          </button>
          {err && <div style={{ color: '#f87171', fontSize: 12, marginTop: 10 }}>{err}</div>}
        </>
      )}
    </div>
  )
}
